import { render, staticRenderFns } from "./v-inlinealerts.vue?vue&type=template&id=2aeeb203&scoped=true&"
import script from "./v-inlinealerts.vue?vue&type=script&lang=js&"
export * from "./v-inlinealerts.vue?vue&type=script&lang=js&"
import style0 from "./v-inlinealerts.vue?vue&type=style&index=0&id=2aeeb203&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeeb203",
  null
  
)

export default component.exports